<template>
  <div
    class="card card-zoom mb-4"
    @mouseover="isHovering = true"
    @mouseout="isHovering = false"
    :class="{'shadow' : isHovering }"
  >
    <!--  <div class="card-header"> -->
    <div class="card-header bg-white border-white p-0 pt-2 pr-2">
      {{ $tc('direccion', 1)}} {{ index+1 }}
      <span
        class="required"
        v-if="editando === true && index===indexEditing"
      >editando...</span>
      <div class="btn-group float-right" role="group">
        <!-- botón editar dirección -->
        <button
          type="button"
          class="btn btn-sm btn-light border btn-gr"
          @click.prevent="editAddressEmit(address, index)"
        >
          <i class="fa fa-2x fa-edit" aria-hidden="true"></i>
        </button>
        <!-- botón eliminar dirección -->
        <button
          type="button"
          class="btn btn-sm btn-light border btn-gr"
          @click.prevent="deleteAddress()"
        >
          <i class="fa fa-2x fa-trash-o" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="card-body">
      <h6 class="card-title">{{ address.address }}</h6>
      {{ address.city }}, {{ address.province }} {{ address.postal_code}}
      <br />
      {{ address.country }}
    </div>
  </div>
</template>

<script>
export default {
  name: "user-address-card",
  props: ["address", "editAddress", "index", "editando", "indexEditing"],
  data() {
    return {
      isHovering: false
    };
  },
  methods: {
    editAddressEmit: function(objAddress, index) {
      this.$emit("editAddress", { objAddress: objAddress, index: index });
    },
    deleteAddress: function() {
      alert("pendiente de implementar....");
    }
  }
};
</script>

<style scoped>
.card {
  transition: transform 0.2s;
  font-size: 0.75em;
}
.card-zoom:hover {
  -ms-transform: scale(1.05); /* IE 9 */
  -webkit-transform: scale(1.05); /* Safari 3-8 */
  transform: scale(1.05);
}
.btn-gr {
  min-width: 35px;
}
</style>